import {Modal, Spin} from "antd";
import React from "react";

interface CustomSpinnerProps {
    message?: string,
    open?: any
}

export default function CustomSpinner({message, open}: CustomSpinnerProps) {
    return (
        <>
            <Modal
                open={open}
                footer={null}
                closable={false}
                centered
            >
                <div style={{textAlign: 'center'}}>
                    <Spin size="large"/>
                    <div style={{marginTop: 16}}>{message}</div>
                </div>
            </Modal>
        </>
    )
}